(function () {
  const ownKeys = ['Moshita preorder quantity', 'Moshita production timing', 'Moshita available-stock quantity'];
  function normalizeProperties(properties) {
    if (properties == null) return {};
    const entries = Array.isArray(properties) ? properties : Object.entries(properties);
    if (entries.some(entry => !Array.isArray(entry) || entry.length !== 2 || typeof entry[0] !== 'string')) throw new Error('Invalid cart properties');
    return Object.fromEntries(entries.filter(([, value]) => value !== null && value !== ''));
  }
  function signature(state, lines) {
    return JSON.stringify({ b2b: state.b2b, items: lines.map(item => ({ id: item.id, quantity: item.quantity, pack: !!item.pack, preorder: item.preorder,
      properties: Object.fromEntries(Object.entries(normalizeProperties(item.properties)).filter(([key]) => !ownKeys.includes(key)).sort(([a], [b]) => a.localeCompare(b))) })) });
  }
  function classify(state) {
    if (!Array.isArray(state.items)) throw new Error('Missing cart items');
    const remaining = new Map();
    const rows = state.items.map(item => {
      if (!Number.isInteger(item.quantity) || item.quantity < 1) throw new Error('Invalid cart quantity');
      const components = item.components?.length ? item.components : [{ id: item.id, quantity: item.quantity, inventory: item.inventory, tracked: item.tracked }];
      const needs = new Map();
      for (const component of components) {
        if (component.tracked === null || component.tracked === '') continue;
        if (!component.tracked || !Number.isFinite(component.inventory) || component.id == null) throw new Error('Missing stock data');
        const perUnit = component.quantity / item.quantity;
        if (!Number.isInteger(perUnit) || perUnit < 1) throw new Error('Invalid bundle quantity');
        const id = String(component.id);
        needs.set(id, (needs.get(id) || 0) + perUnit);
        const available = Math.max(0, component.inventory);
        remaining.set(id, remaining.has(id) ? Math.min(remaining.get(id), available) : available);
      }
      return { item, needs };
    });
    return rows.map(({ item, needs }) => {
      let stocked = item.quantity;
      for (const [id, perUnit] of needs) stocked = Math.min(stocked, Math.floor(remaining.get(id) / perUnit));
      // Reserve all available components required by this line, including partial preorder packs.
      for (const [id, perUnit] of needs) remaining.set(id, Math.max(0, remaining.get(id) - perUnit * item.quantity));
      return { ...item, stocked, preorder: item.quantity - stocked };
    });
  }
  function unit(item, quantity, text) { return text[item.pack ? (quantity === 1 ? 'pack' : 'packs') : (quantity === 1 ? 'piece' : 'pieces')]; }
  function propertiesFor(line, text) {
    const properties = normalizeProperties(line.properties);
    properties[ownKeys[0]] = line.preorder ? line.preorder + ' ' + unit(line, line.preorder, text) : '';
    properties[ownKeys[1]] = line.preorder ? text.timing : '';
    properties[ownKeys[2]] = line.preorder ? line.stocked + ' ' + unit(line, line.stocked, text) : '';
    return properties;
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { classify, normalizeProperties, signature, propertiesFor }; return; }
  const dialog = document.getElementById('moshita-preorder-dialog');
  if (!dialog || window.moshitaPreorderReady) return;
  window.moshitaPreorderReady = true;
  const text = JSON.parse(document.getElementById('moshita-preorder-text').textContent);
  const root = window.Shopify?.routes?.root || '/';
  const title = dialog.querySelector('[data-title]'), message = dialog.querySelector('[data-message]'), list = dialog.querySelector('[data-items]');
  const accept = dialog.querySelector('[data-accept]'), acceptance = dialog.querySelector('[data-acceptance]'), next = dialog.querySelector('[data-continue]');
  const error = dialog.querySelector('[data-error]'), review = dialog.querySelector('[data-review]');
  let busy = false, reviewing = null, trigger = null, lastCartEdit = 0;
  document.addEventListener('change', event => { if (event.target.closest('cart-items,cart-drawer-items')) lastCartEdit = Date.now(); }, true);
  async function request(url, body) {
    const response = await fetch(root + url, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(20000), ...(body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : {}) });
    if (!response.ok) throw new Error('Cart request failed');
    return response;
  }
  async function settleCart() {
    const start = Date.now();
    while (Date.now() - lastCartEdit < 800 || document.querySelector('cart-drawer.loading,.cart__items--disabled,.cart-drawer__items--disabled,product-form .loading')) {
      if (Date.now() - start > 15000) throw new Error('Cart update still pending');
      await new Promise(resolve => setTimeout(resolve, 100));
    }
  }
  async function read() {
    const response = await request('cart?section_id=moshita-preorder-state');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const node = html.getElementById('moshita-preorder-state');
    if (!node) throw new Error('Stock check unavailable');
    return JSON.parse(node.textContent);
  }
  function show(state, lines) {
    reviewing = signature(state, lines);
    title.textContent = text.heading; message.textContent = text.notice;
    list.replaceChildren();
    for (const item of lines.filter(line => line.preorder > 0)) {
      const row = document.createElement('li'), name = document.createElement('strong'), quantities = document.createElement('span');
      name.textContent = item.title;
      quantities.textContent = text.stocked.replace('[quantity]', item.stocked).replace('[unit]', unit(item, item.stocked, text)) + ' · ' + text.preorder.replace('[quantity]', item.preorder).replace('[unit]', unit(item, item.preorder, text));
      row.append(name, quantities); list.append(row);
    }
    acceptance.hidden = false; accept.checked = false; next.hidden = false; next.disabled = true; error.textContent = '';
    if (!dialog.open) dialog.showModal();
  }
  function fail() {
    title.textContent = text.error_heading; message.textContent = text.error; list.replaceChildren();
    acceptance.hidden = true; next.hidden = true; error.textContent = '';
    if (!dialog.open) dialog.showModal();
  }
  async function save(state, lines) {
    const expected = signature(state, lines);
    for (let index = 0; index < lines.length; index++) {
      const line = lines[index], old = normalizeProperties(line.properties), wanted = propertiesFor(line, text);
      if (ownKeys.every(key => (old[key] || '') === wanted[key])) continue;
      // Resolve fresh line keys after each update; fail safely if Shopify merges or changes lines.
      const current = await read(), fresh = classify(current);
      if (signature(current, fresh) !== expected) throw new Error('Cart changed before metadata save');
      const response = await request('cart/change.js', { id: fresh[index].key, quantity: line.quantity, properties: wanted });
      const result = await response.json();
      if (result.errors || result.status) throw new Error('Cart rejected preorder details');
    }
    const preorder = lines.filter(line => line.preorder > 0), hasPreorder = preorder.length > 0;
    await request('cart/update.js', { attributes: {
      'Moshita preorder status': hasPreorder ? 'PREORDER:PRODUCTION-REVIEW:2026-10-15' : '',
      'Moshita preorder audience': hasPreorder ? (state.b2b ? 'Wholesale' : 'Retail') : '',
      'Moshita preorder items': hasPreorder ? preorder.map(line => line.preorder + ' ' + unit(line, line.preorder, text) + ' × ' + line.title).join('; ') : '',
      'Moshita preorder terms': hasPreorder ? text.notice : '',
      'Moshita preorder acknowledged': hasPreorder ? new Date().toISOString() : ''
    } });
    const current = await read(), verified = classify(current);
    if (signature(current, verified) !== expected) throw new Error('Cart changed during stock check');
    for (const line of verified) {
      const actual = normalizeProperties(line.properties), wanted = propertiesFor(line, text);
      if (ownKeys.some(key => (actual[key] || '') !== wanted[key])) throw new Error('Preorder details were not saved');
    }
    window.location.assign(root + 'checkout');
  }
  async function check() {
    if (busy) return;
    busy = true;
    try {
      await settleCart();
      const state = await read(), lines = classify(state);
      if (!lines.length) return;
      if (lines.some(line => line.preorder > 0)) show(state, lines);
      else await save(state, lines);
    } catch { fail(); } finally { busy = false; }
  }
  function intercept(event) {
    const checkout = event.target.closest?.('[name="checkout"],a[href]');
    const href = checkout?.getAttribute('href');
    const url = href ? new URL(href, location.href) : null;
    if (!(checkout?.name === 'checkout' || (url && url.origin === location.origin && /\/checkout\/?$/.test(url.pathname)))) return;
    event.preventDefault(); event.stopImmediatePropagation(); trigger = checkout; check();
  }
  document.addEventListener('click', intercept, true);
  document.addEventListener('submit', event => {
    const implicitCart = !event.submitter && event.target.matches('form[action$="/cart"]');
    if (event.submitter?.name !== 'checkout' && !implicitCart) return;
    event.preventDefault(); event.stopImmediatePropagation(); trigger = event.submitter; check();
  }, true);
  accept.addEventListener('change', () => { next.disabled = busy || !accept.checked; });
  review.addEventListener('click', () => { if (!busy) { dialog.close(); trigger?.focus(); } });
  dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); else reviewing = null; });
  next.addEventListener('click', async () => {
    if (busy || !accept.checked) return;
    busy = true; next.disabled = true; review.disabled = true; error.textContent = '';
    try {
      await settleCart();
      const state = await read(), lines = classify(state);
      if (signature(state, lines) !== reviewing) {
        if (lines.some(line => line.preorder > 0)) { show(state, lines); error.textContent = text.changed; }
        else await save(state, lines);
        return;
      }
      await save(state, lines);
    } catch { error.textContent = text.error; }
    finally { busy = false; review.disabled = false; next.disabled = !accept.checked; }
  });
})();
